<template>
  <hic-list-page hide-keyword ref="listPage" title="" :entities="entities" :condition="condition" @load="page" :loading="meta.loading" :span-method="mergeByNo" hide-search-dialog>
    <template slot="buttons">
      <el-button type="primary" size="small" icon="el-icon-document-add" @click="creator">申请会诊</el-button>
    </template>
    <template slot="search"> </template>
    <el-table-column align="center" label="操作" width="100">
      <template slot-scope="{ row }">
        <el-button @click.native="edit(row)" type="primary" :disabled="row.state != '已撤销' && row.state != '已拒绝'" size="mini" icon="el-icon-edit" circle plain></el-button>
        <el-popconfirm confirm-button-text="确定" cancel-button-text="取消" icon="el-icon-info" icon-color="red" :title="`确定要${row.state != '申请中' ? '删除' : '撤销'}该会诊吗？`" @confirm="del(row)">
          <el-button class="left-pad" slot="reference" :disabled="row.state == '已会诊' || row.state == '已接受' || row.state == '已撤销'" type="danger" size="mini" icon="el-icon-delete" circle plain></el-button>
        </el-popconfirm>
      </template>
    </el-table-column>
    <el-table-column align="center" label="No." column-key="no" prop="no" width="150">
      <!-- <template slot-scope="{ row }">
        <el-link @click.native="info(row)" type="primary">{{ row.no || "流水号" }}</el-link>
      </template> -->
    </el-table-column>
    <el-table-column align="center" label="状态" :filters="dictEnum.ConsultationState" :filter-multiple="false" column-key="state" prop="state" width="80">
      <template slot-scope="{ row }">
        <el-tag v-if="row.state == '已接受'" type="success" size="small" hit>{{ row.state }}</el-tag>
        <el-tag v-else-if="row.state == '已拒绝'" type="danger" size="small" hit>{{ row.state }}</el-tag>
        <el-tag v-else-if="row.state == '已撤销'" type="warning" size="small" hit>{{ row.state }}</el-tag>
        <el-tag v-else-if="row.state == '申请中'" type="primary" size="small" hit>{{ row.state }}</el-tag>
        <el-tag v-else type="info" size="small" hit>{{ row.state }}</el-tag>
      </template>
    </el-table-column>
    <el-table-column align="center" label="类型" :filters="dict.ConsultationType" :filter-multiple="false" column-key="type" prop="type" width="80">
      <template slot-scope="{ row }">
        {{ row.type | dictText("ConsultationType") }}
      </template>
    </el-table-column>
    <el-table-column
      align="center"
      label="加急"
      :filters="[
        { value: true, text: '是' },
        { value: false, text: '否' },
      ]"
      :filter-multiple="false"
      column-key="ifEmergency"
      prop="ifEmergency"
      width="80"
    >
      <template slot-scope="{ row }">
        <el-tag v-if="row.ifEmergency" type="danger" size="small" hit>是</el-tag>
      </template>
    </el-table-column>
    <el-table-column align="left" label="会诊目的" prop="purpose" show-overflow-tooltip> </el-table-column>
    <el-table-column align="left" width="120;" :filters="dict.Dept" :filter-multiple="false" column-key="targetDeptCode" label="会诊科室" prop="targetDeptCode">
      <template slot-scope="{ row }">{{ row.targetDeptCode | dictText("Dept") }}</template>
    </el-table-column>
    <el-table-column align="center" width="120" label="会诊医师" prop="targetDoctorName"></el-table-column>
    <el-table-column align="center" width="120" sortable="custom" label="会诊日期" prop="appDate">
      <template slot-scope="{ row }">{{ row.execDate | fmtDate }}</template>
    </el-table-column>
    <el-table-column align="center" width="120" label="计划会诊日期" prop="planDate">
      <template slot-scope="{ row }">{{ row.planDate | fmtDate }}</template>
    </el-table-column>
    <el-table-column align="center" width="120" label="申请医师" prop="doctorName"></el-table-column>

    <el-table-column width="120" align="left" label="申请科室" :filters="dict.Dept" filter-multiple column-key="targetDeptCode">
      <template slot-scope="{ row }">{{ row.deptCode | dictText("Dept") }}</template>
    </el-table-column>

    <el-table-column align="center" width="120" sortable="custom" label="申请时间" prop="appDate">
      <template slot-scope="{ row }">{{ row.appDate | fmtDate }}</template>
    </el-table-column>

    <consultationEditor v-if="meta.editor" v-model="value" :entity="entity" @ok="page" :visible.sync="meta.editor"> </consultationEditor>
    <consultationInfo v-if="meta.info" :detailValue="value" :entity="entity" title="会诊详情" @ok="page" :visible.sync="meta.info"> </consultationInfo>
  </hic-list-page>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      entity: Object,
    },
    components: {
      consultationEditor: () => import("./consultation_editor.vue"),
      consultationInfo: () => import("./consultation_info.vue"),
    },
    data() {
      return {
        meta: {
          loading: false,
          editor: false,
          info: false,
        },
        condition: {
          keyword: null,
          sort: "no,id",
          asc: false,
          pageSize: 10,
          pageIndexOnView: 1,
        },
        entities: {
          items: [],
        },
        value: {},
      };
    },
    watch: {
      entity() {
        this.page();
      },
    },
    computed: {
      ...mapGetters(["dict", "dictEnum", "user"]),
    },
    created() {
      this.page();
    },
    mounted() {},
    methods: {
      page() {
        this.condition.ipNo = this.entity.ipNo
        this.condition.deptCode = this.user.deptCode
        this.meta.loading = true;
        api.Consultation.query(this.condition)
          .then((res) => {
            this.entities = res;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally((f) => {
            this.meta.loading = false;
          });
      },
      creator() {
        this.value = {
          ipNo: this.entity.ipNo,
          bedNo: this.entity.bedNo,
          patientCode: this.entity.patientCode,
          patientName: this.entity.patientName,
          doctorCode: this.user.code,
          doctorName: this.user.name,
          deptCode: this.user.deptCode,
          appDate: this.$utils.Dt.now(),
          planDate: this.$utils.Dt.now(),
          hospitalizationId: this.entity.id,
          state: "草稿",
          diagnosisName: this.entity.diagnosisName,
          targets: []
        };
        this.meta.editor = true;
      },
      mergeByNo({ row, column, rowIndex, columnIndex }) {
        if (columnIndex != 1) {
          return [1, 1];
        }

        var sames = this.entities.items.filter(consultation => consultation.no == row.no);
        if (row.id == sames[0].id) {
          return [sames.length, 1];
        } else {
          return [0, 1];
        }
      },
      edit(row) {
        this.value = this.$utils.Obj.clone(row);
        this.meta.editor = true;
      },
      del(row) {
        if (row.state == "申请中") {
          api.Consultation.patch({ id: row.id, state: "已撤销" })
            .then((res) => {
              this.$message.success("撤销成功!");
              this.page();
            })
            .catch((err) => {
              this.$message.error(err);
            });
          return;
        }

        api.Consultation.del(row.id)
          .then((res) => {
            this.$message.success("删除成功!");
            this.page();
          })
          .catch((err) => {
            this.$message.error(err);
          });
      },
      info(row) {
        this.value = row;
        this.meta.info = true;
      },
    },
  };
</script>
